import { BaseObject } from "../../../../../shared/baseObject";

export class VisualObjectOptions {
}